import { AIIcon } from '@/components/icons/AIIcon'

const GenerationProgress = ({ progress }) => {
    const { current, total, percentage } = progress

    return (
        <div className="tw:px-6 tw:py-4 tw:bg-gray-500 tw:mt-6 tw:rounded-xs">
            <div className="tw:flex tw:items-start tw:gap-3">
                <div className="tw:p-2 tw:size-10 tw:rounded-full tw:bg-gray-300 tw:flex tw:items-center tw:justify-center">
                    <AIIcon size={20} />
                </div>
                <div className="tw:flex-1">
                    <div className="tw:flex tw:items-center tw:justify-between">
                        <span className="tw:text-sm tw:font-medium">AI Generator is creating images...</span>
                        <span className="tw:text-sm tw:text-white">{percentage}%</span>
                    </div>
                    <div className="tw:text-sm tw:text-gray-400">
                        {current + 1} of {total} images
                    </div>
                    <div className="tw:w-full tw:bg-gray-300 tw:rounded-full tw:h-1 tw:overflow-hidden tw:mt-1.5">
                        <div
                            className="tw:bg-blue-300 tw:h-full tw:rounded-full tw:transition-all tw:duration-1000 tw:ease-out"
                            style={{ width: `${percentage}%` }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GenerationProgress
